var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4C5.34315 4 4 5.34315 4 7V8.17071C2.83481 8.58254 2 9.69378 2 11V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V11C22 9.69378 21.1652 8.58254 20 8.17071V7C20 5.34315 18.6569 4 17 4H7ZM19 10H5C4.44772 10 4 10.4477 4 11V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V11C20 10.4477 19.5523 10 19 10ZM18 8V7C18 6.44772 17.5523 6 17 6H7C6.44772 6 6 6.44772 6 7V8H18Z",
    fill: "#296D9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12C17.5523 12 18 12.4477 18 13Z",
    fill: "#296D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBlue);
export default __webpack_public_path__ + "static/media/list_blue.bcce26ed296e6597e17c73280ce5afc0.svg";
export { ForwardRef as ReactComponent };